import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const faqs = [{
  q: '¿Esto sirve si estoy estudiando?',
  a: 'Sí, te da claridad práctica desde el inicio, complementando perfectamente tu formación teórica con herramientas reales de guardia.'
}, {
  q: '¿Funciona en Argentina?',
  a: '¡Sí! El material está adaptado a la realidad local y protocolos utilizados en nuestro país.'
}, {
  q: '¿Necesito experiencia previa?',
  a: 'No, podés empezar desde cero. El sistema está diseñado para guiarte paso a paso, seas estudiante o profesional.'
}, {
  q: '¿Qué pasa si no me gusta?',
  a: 'Tenés garantía total de 7 días. Si sentís que el material no es para ti, nos envías un correo y te devolvemos el 100% de tu dinero sin hacer preguntas.'
}, {
  q: '¿Es digital o físico?',
  a: 'Es 100% digital. Recibirás acceso inmediato a todo el material en formato PDF de alta calidad, listo para descargar y usar en tu celular o imprimir.'
}, {
  q: '¿Cómo accedo al material?',
  a: 'Inmediatamente después de tu compra, recibirás un correo electrónico con tus datos de acceso para descargar todo el contenido.'
}];
export function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="bg-brand-dark py-5 px-5" data-id="element-105">
      <div className="max-w-xl mx-auto" data-id="element-106">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-white mb-8" data-id="element-107">
          ❓ Preguntas Frecuentes
        </h2>

        <div className="space-y-3" data-id="element-108">
          {faqs.map((faq, idx) => <div key={idx} className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl overflow-hidden transition-all" data-id="element-109">
              <button className="w-full px-5 py-4 text-left flex justify-between items-center hover:bg-white/10 focus:outline-none transition-colors" onClick={() => setOpenIdx(openIdx === idx ? null : idx)} data-id="element-110">
                <span className="font-bold text-white text-sm pr-4" data-id="element-111">
                  {faq.q}
                </span>
                {openIdx === idx ? <ChevronUp className="text-brand-yellow flex-shrink-0" size={18} data-id="element-112" /> : <ChevronDown className="text-gray-600 flex-shrink-0" size={18} data-id="element-113" />}
              </button>
              {openIdx === idx && <div className="px-5 pb-4 text-sm text-gray-400 leading-relaxed border-t border-gray-800" data-id="element-114">
                  <div className="pt-3" data-id="element-115">{faq.a}</div>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}